var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('b-button',{attrs:{"variant":"primary"}},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('i',{staticClass:"ri-arrow-right-line align-middle ml-2"})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }